// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"64":"cf02002a","224":"e2f85284","258":"fde54e29","458":"5e263489"}[chunkId] + ".chunk.css";
};